<smallstack-type-select
  [selectedTypePath]="value()"
  (selectedTypePathChange)="setValue($event)"
  attr.data-test="schema-form-widget-types-{{ path() }}"
  [usePlural]="usePlural()"
></smallstack-type-select>
